<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item><i class="el-icon-lx-calendar" /> 查询管理</el-breadcrumb-item>
        <el-breadcrumb-item>H5扫码页配置</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="container">
      <div class="default-display">
        <div class="default-item">
          <div class="default-label">默认轮播图首图</div>
          <div class="default-sub">{{ defaults.showBanner ? '未单独配置：显示' : '未单独配置：不显示' }}</div>
          <div class="preview-frame">
            <el-image
              v-if="defaults.banner1"
              class="default-image"
              :src="defaults.banner1"
              fit="contain"
              :preview-src-list="[defaults.banner1]"
            />
            <span v-else class="empty-text">暂无图片</span>
          </div>
        </div>
        <div class="default-item">
          <div class="default-label">默认背景色色块</div>
          <div class="preview-frame">
            <div class="color-cell">
              <span class="swatch" :style="{ backgroundColor: normalizeColor(defaults.bgColor) }" />
              <span>{{ defaults.bgColor || '#FFFFFF' }}</span>
            </div>
          </div>
        </div>
        <div class="default-item">
          <div class="default-label">默认logo图</div>
          <div class="preview-frame">
            <el-image
              v-if="defaults.logo"
              class="default-image"
              :src="defaults.logo"
              fit="contain"
              :preview-src-list="[defaults.logo]"
            />
            <span v-else class="empty-text">暂无图片</span>
          </div>
        </div>
        <div class="default-action">
          <el-button type="primary" @click="openDefaultDialog">配置默认值</el-button>
          <el-button @click="loadDefaults">刷新</el-button>
        </div>
      </div>

      <el-divider />

      <div class="handle-box">
        <el-form :inline="true" size="small" @keyup.enter.native="loadRows">
          <el-form-item label="产品编码">
            <el-input v-model="search.productCode" clearable placeholder="模糊查询" style="width:220px" />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="loadRows">搜索</el-button>
            <el-button @click="resetSearch">重置</el-button>
            <el-button type="success" @click="openAdd">新增配置</el-button>
          </el-form-item>
        </el-form>
      </div>

      <el-table v-loading="loading" :data="rows" border stripe size="small" style="width:100%">
        <el-table-column prop="product_code" label="产品编码" min-width="140" />
        <el-table-column prop="product_name" label="产品名称" min-width="180" />
        <el-table-column label="轮播图首图" min-width="220">
          <template slot-scope="s">
            <el-image
              v-if="s.row.banner1"
              class="table-image"
              :src="s.row.banner1"
              fit="contain"
              :preview-src-list="[s.row.banner1]"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="背景色色块" width="140">
          <template slot-scope="s">
            <div class="color-cell">
              <span class="swatch" :style="{ backgroundColor: normalizeColor(s.row.bgColor) }" />
              <span>{{ s.row.bgColor || '-' }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="logo图" min-width="180">
          <template slot-scope="s">
            <el-image
              v-if="s.row.logo"
              class="table-image"
              :src="s.row.logo"
              fit="contain"
              :preview-src-list="[s.row.logo]"
            />
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="150" fixed="right">
          <template slot-scope="s">
            <el-button type="text" size="small" @click="openEdit(s.row)">修改</el-button>
            <el-button type="text" size="small" style="color:#f56c6c" @click="removeRow(s.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        style="margin-top:12px"
        background
        layout="total, prev, pager, next, sizes"
        :total="pager.total"
        :page-sizes="[10,20,50,100]"
        :page-size.sync="pager.pageSize"
        :current-page.sync="pager.pageIndex"
        @current-change="handlePageChange"
        @size-change="handleSizeChange"
      />

      <el-dialog :title="dialogMode === 'add' ? '新增H5扫码页配置' : '修改H5扫码页配置'" :visible.sync="dialogVisible" width="620px" :close-on-click-modal="false">
        <el-form :model="form" label-width="130px" size="small">
          <el-form-item label="产品编码">
            <el-select
              v-model="form.product_code"
              style="width:100%"
              clearable
              filterable
              remote
              :disabled="dialogMode==='edit'"
              placeholder="请输入产品名称或编码模糊匹配"
              :remote-method="getProductSelectList"
              :loading="productSelectLoading"
            >
              <el-option
                v-for="item in productSelectList"
                :key="item.product_code"
                :label="item.product"
                :value="item.product_code"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="轮播图">
            <el-upload
              list-type="picture-card"
              accept="image/*"
              multiple
              :file-list="uploadFiles.formBannerList"
              :http-request="uploadBannerImage"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleBannerRemove"
            >
              <i class="el-icon-plus" />
            </el-upload>
            <div class="upload-tip">可上传多张，系统按首图作为列表展示图</div>
          </el-form-item>
          <el-form-item label="背景色色块">
            <div class="color-picker-row">
              <el-color-picker v-model="form.bgColor" color-format="hex" :predefine="predefineColors" />
              <span class="color-value">{{ form.bgColor || '#FFFFFF' }}</span>
            </div>
          </el-form-item>
          <el-form-item label="logo图">
            <el-upload
              :class="{ 'hide-upload-trigger': uploadFiles.formLogo.length >= 1 }"
              list-type="picture-card"
              accept="image/*"
              :limit="1"
              :file-list="uploadFiles.formLogo"
              :http-request="(req) => uploadImage(req, form, 'logo', 'formLogo')"
              :on-preview="handlePictureCardPreview"
              :on-remove="() => clearImage(form, 'logo', 'formLogo')"
              :on-exceed="() => handleUploadExceed('logo图只允许上传一张图片')"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitForm">{{ dialogMode === 'add' ? '新 增' : '保 存' }}</el-button>
        </span>
      </el-dialog>

      <el-dialog title="配置默认值" :visible.sync="defaultDialogVisible" width="620px" :close-on-click-modal="false">
        <el-form :model="defaultForm" label-width="130px" size="small">
          <el-form-item label="默认轮播是否显示">
            <el-switch v-model="defaultForm.showBanner" active-text="显示" inactive-text="不显示" />
            <div class="upload-tip">只对没有单独配置轮播图的产品生效；已单独配置的产品仍显示自己的轮播图</div>
          </el-form-item>
          <el-form-item label="默认轮播图首图">
            <el-upload
              list-type="picture-card"
              accept="image/*"
              multiple
              :file-list="uploadFiles.defaultsBanner1"
              :http-request="uploadDefaultBannerImage"
              :on-preview="handlePictureCardPreview"
              :on-remove="handleDefaultBannerRemove"
            >
              <i class="el-icon-plus" />
            </el-upload>
            <div class="upload-tip">默认轮播图支持多张，新增配置会继承该默认轮播图组</div>
          </el-form-item>
          <el-form-item label="默认背景色色块">
            <div class="color-picker-row">
              <el-color-picker v-model="defaultForm.bgColor" color-format="hex" :predefine="predefineColors" />
              <span class="color-value">{{ defaultForm.bgColor || '#FFFFFF' }}</span>
            </div>
          </el-form-item>
          <el-form-item label="默认logo图">
            <el-upload
              :class="{ 'hide-upload-trigger': uploadFiles.defaultsLogo.length >= 1 }"
              list-type="picture-card"
              accept="image/*"
              :limit="1"
              :file-list="uploadFiles.defaultsLogo"
              :http-request="(req) => uploadImage(req, defaultForm, 'logo', 'defaultsLogo')"
              :on-preview="handlePictureCardPreview"
              :on-remove="() => clearImage(defaultForm, 'logo', 'defaultsLogo')"
              :on-exceed="() => handleUploadExceed('默认logo图只允许上传一张图片')"
            >
              <i class="el-icon-plus" />
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="defaultDialogVisible = false">取 消</el-button>
          <el-button :loading="defaultSaving" type="primary" @click="saveDefaults">保 存</el-button>
        </span>
      </el-dialog>

      <el-dialog :visible.sync="previewVisible" width="620px" append-to-body>
        <img width="100%" :src="previewImageUrl" alt="preview">
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  h5scanpageconfigpagelist,
  h5scanpageconfigadd,
  h5scanpageconfigedit,
  h5scanpageconfigdel,
  productlist,
  productupLoad2
} from '@/api/base'
import { produceMtConfigGet, produceMtConfigEdit } from '@/api/plant'

const KEY_DEFAULT_BANNER = 'h5_scan_default_banner1'
const KEY_DEFAULT_BANNER_SHOW = 'h5_scan_default_banner_show'
const KEY_DEFAULT_BG = 'h5_scan_default_bg_color'
const KEY_DEFAULT_LOGO = 'h5_scan_default_logo'

export default {
  name: 'H5ScanPageConfig',
  data() {
    return {
      loading: false,
      defaultSaving: false,
      productSelectLoading: false,
      productSelectList: [],
      search: { productCode: '' },
      pager: { pageIndex: 1, pageSize: 20, total: 0 },
      rows: [],
      defaults: {
        banner1: '',
        bannerList: [],
        showBanner: true,
        bgColor: '',
        logo: ''
      },
      dialogVisible: false,
      defaultDialogVisible: false,
      dialogMode: 'add',
      previewVisible: false,
      previewImageUrl: '',
      uploadFiles: {
        defaultsBanner1: [],
        defaultsLogo: [],
        formBannerList: [],
        formLogo: []
      },
      predefineColors: [
        '#FFFFFF',
        '#000000',
        '#409EFF',
        '#67C23A',
        '#E6A23C',
        '#F56C6C',
        '#909399'
      ],
      form: {
        id: null,
        product_code: '',
        banner1: '',
        bannerList: [],
        bgColor: '',
        logo: ''
      },
      defaultForm: {
        banner1: '',
        bannerList: [],
        showBanner: true,
        bgColor: '#FFFFFF',
        logo: ''
      }
    }
  },
  mounted() {
    this.loadDefaults()
    this.loadRows()
  },
  methods: {
    normalizeColor(v) {
      if (!v) return '#ffffff'
      return v
    },
    normalizeHexColor(v) {
      const raw = (v || '').toString().trim()
      if (!raw) return '#FFFFFF'
      if (raw.startsWith('#')) {
        if (raw.length === 4) {
          return `#${raw[1]}${raw[1]}${raw[2]}${raw[2]}${raw[3]}${raw[3]}`.toUpperCase()
        }
        return raw.toUpperCase()
      }
      const rgbaMatch = raw.match(/^rgba?\((\d+)\s*,\s*(\d+)\s*,\s*(\d+)/i)
      if (!rgbaMatch) return '#FFFFFF'
      const toHex = (n) => Math.max(0, Math.min(255, Number(n))).toString(16).padStart(2, '0')
      return `#${toHex(rgbaMatch[1])}${toHex(rgbaMatch[2])}${toHex(rgbaMatch[3])}`.toUpperCase()
    },
    handleUploadExceed(message) {
      this.$message.warning(message || '该字段只允许上传一张图片')
    },
    handlePictureCardPreview(file) {
      const url = this.normalizeImageUrl(file.url || '')
      if (!url) return
      this.previewImageUrl = url
      this.previewVisible = true
    },
    setFileList(fileKey, url) {
      const normalized = this.normalizeImageUrl(url)
      this.$set(this.uploadFiles, fileKey, normalized ? [{ name: 'image', url: normalized }] : [])
    },
    clearImage(target, field, fileKey) {
      target[field] = ''
      this.setFileList(fileKey, '')
    },
    normalizeFileList(fileList) {
      return (fileList || []).map((f, i) => ({
        name: f.name || `image_${i + 1}`,
        url: this.normalizeImageUrl(f.url || (f.response && f.response.data) || '')
      })).filter(f => !!f.url)
    },
    normalizeImageUrl(v) {
      let url = (v || '').toString().trim()
      if (!url) return ''
      try {
        url = decodeURIComponent(url)
      } catch (e) {
        // keep raw when decode fails
      }
      if (/^https?:\/\//i.test(url)) return url
      if (/^https?:%2f%2f/i.test(url)) {
        try {
          return decodeURIComponent(url)
        } catch (e) {
          return ''
        }
      }
      return url
    },
    syncBannerByFileList(fileList) {
      const normalized = this.normalizeFileList(fileList)
      this.$set(this.uploadFiles, 'formBannerList', normalized)
      this.form.bannerList = normalized.map(f => f.url)
      this.form.banner1 = this.form.bannerList[0] || ''
    },
    syncDefaultBannerByFileList(fileList) {
      const normalized = this.normalizeFileList(fileList)
      this.$set(this.uploadFiles, 'defaultsBanner1', normalized)
      this.defaultForm.bannerList = normalized.map(f => f.url)
      this.defaultForm.banner1 = this.defaultForm.bannerList[0] || ''
    },
    parseBannerJson(v) {
      if (!v) return []
      const raw = (v || '').toString().trim()
      const parseToList = (input) => {
        if (!input) return []
        try {
          const parsed = JSON.parse(input)
          if (Array.isArray(parsed)) {
            return parsed
              .filter(x => typeof x === 'string' && x.trim())
              .map(x => this.normalizeImageUrl(x.trim()))
              .filter(Boolean)
          }
          if (typeof parsed === 'string') {
            return parseToList(parsed)
          }
          return []
        } catch (e) {
          return []
        }
      }
      let list = parseToList(raw)
      if (list.length) return list
      let decoded = raw
      try {
        decoded = decodeURIComponent(raw)
      } catch (e) {
        decoded = raw
      }
      list = parseToList(decoded)
      if (list.length) return list
      // 兼容旧格式：逗号分隔字符串
      if (decoded.includes(',')) {
        return decoded.split(',')
          .map(x => this.normalizeImageUrl(x))
          .filter(Boolean)
      }
      try {
        const single = this.normalizeImageUrl(decoded.replace(/^"+|"+$/g, ''))
        return single ? [single] : []
      } catch (e) {
        return []
      }
    },
    getBannerFirst(bannerList, fallback = '') {
      return (bannerList && bannerList.length ? bannerList[0] : '') || fallback || ''
    },
    uploadBannerImage(request) {
      const formData = new FormData()
      const file = new window.File([request.file], request.file.name)
      formData.append('formFile', file, request.file.name)
      productupLoad2(formData).then(res => {
        const url = this.normalizeImageUrl(res.data || '')
        const next = [...this.uploadFiles.formBannerList, { name: request.file.name, url }]
        this.syncBannerByFileList(next)
        this.$message.success('上传成功')
      }).catch(() => {
        this.$message.error('上传失败')
      })
    },
    uploadDefaultBannerImage(request) {
      const formData = new FormData()
      const file = new window.File([request.file], request.file.name)
      formData.append('formFile', file, request.file.name)
      productupLoad2(formData).then(res => {
        const url = this.normalizeImageUrl(res.data || '')
        const next = [...this.uploadFiles.defaultsBanner1, { name: request.file.name, url }]
        this.syncDefaultBannerByFileList(next)
        this.$message.success('上传成功')
      }).catch(() => {
        this.$message.error('上传失败')
      })
    },
    handleBannerRemove(file, fileList) {
      this.syncBannerByFileList(fileList)
    },
    handleDefaultBannerRemove(file, fileList) {
      this.syncDefaultBannerByFileList(fileList)
    },
    uploadImage(request, target, field, fileKey) {
      const formData = new FormData()
      const file = new window.File([request.file], request.file.name)
      formData.append('formFile', file, request.file.name)
      productupLoad2(formData).then(res => {
        const url = this.normalizeImageUrl(res.data || '')
        target[field] = url
        this.setFileList(fileKey, url)
        this.$message.success('上传成功')
      }).catch(() => {
        this.$message.error('上传失败')
      })
    },
    getProductSelectList(value) {
      if (!value) {
        this.productSelectList = []
        return
      }
      this.productSelectLoading = true
      setTimeout(() => {
        productlist({ productName: value }).then(response => {
          const list = response.data.data || []
          this.productSelectList = list.map(item => ({
            ...item,
            product: `${item.product_code} - ${item.product_name}`
          }))
        }).finally(() => {
          this.productSelectLoading = false
        })
      }, 200)
    },
    getConfigValue(confKey) {
      return produceMtConfigGet(confKey).then(res => {
        const item = res.data || {}
        const value = item.conf_value != null ? item.conf_value : item.confValue
        return value == null ? '' : value
      })
    },
    parseShowFlag(v) {
      const raw = (v == null ? '' : String(v)).trim().toLowerCase()
      if (!raw) return true
      return raw !== '0' && raw !== 'false'
    },
    loadDefaults() {
      Promise.all([
        this.getConfigValue(KEY_DEFAULT_BANNER),
        this.getConfigValue(KEY_DEFAULT_BG),
        this.getConfigValue(KEY_DEFAULT_LOGO),
        this.getConfigValue(KEY_DEFAULT_BANNER_SHOW)
      ]).then(([bannerRaw, bgColor, logo, showRaw]) => {
        let bannerList = this.parseBannerJson(bannerRaw)
        if (!bannerList.length && bannerRaw) {
          bannerList = [this.normalizeImageUrl(bannerRaw)]
        }
        this.defaults.bannerList = bannerList
        this.defaults.banner1 = this.getBannerFirst(bannerList)
        this.defaults.bgColor = this.normalizeHexColor(bgColor)
        this.defaults.logo = this.normalizeImageUrl(logo || '')
        this.defaults.showBanner = this.parseShowFlag(showRaw)
      }).catch(() => {
        this.$message.warning('默认配置读取失败，请确认系统配置 key 已存在')
      })
    },
    openDefaultDialog() {
      this.defaultForm = {
        banner1: this.defaults.banner1 || '',
        bannerList: this.defaults.bannerList && this.defaults.bannerList.length ? [...this.defaults.bannerList] : (this.defaults.banner1 ? [this.defaults.banner1] : []),
        showBanner: this.defaults.showBanner !== false,
        bgColor: this.normalizeHexColor(this.defaults.bgColor),
        logo: this.defaults.logo || ''
      }
      this.syncDefaultBannerByFileList((this.defaultForm.bannerList || []).map((url, i) => ({ name: `default_banner_${i + 1}`, url })))
      this.setFileList('defaultsLogo', this.defaultForm.logo)
      this.defaultDialogVisible = true
    },
    saveDefaults() {
      this.defaultSaving = true
      this.defaultForm.banner1 = this.getBannerFirst(this.defaultForm.bannerList)
      this.defaultForm.bgColor = this.normalizeHexColor(this.defaultForm.bgColor)
      if (this.defaultForm.showBanner && !this.defaultForm.banner1) {
        this.$message.warning('显示默认轮播时请至少上传一张默认轮播图')
        this.defaultSaving = false
        return
      }
      Promise.all([
        produceMtConfigEdit(KEY_DEFAULT_BANNER, JSON.stringify(this.defaultForm.bannerList || [])),
        produceMtConfigEdit(KEY_DEFAULT_BANNER_SHOW, this.defaultForm.showBanner ? '1' : '0'),
        produceMtConfigEdit(KEY_DEFAULT_BG, this.defaultForm.bgColor || ''),
        produceMtConfigEdit(KEY_DEFAULT_LOGO, this.defaultForm.logo || '')
      ]).then(() => {
        this.defaults = { ...this.defaultForm }
        this.defaultDialogVisible = false
        this.$message.success('默认值保存成功')
      }).catch(() => {
        this.$message.error('默认值保存失败，请确认 key 已存在')
      }).finally(() => {
        this.defaultSaving = false
      })
    },
    loadRows() {
      this.loading = true
      h5scanpageconfigpagelist({
        product_code: this.search.productCode || '',
        currPage: this.pager.pageIndex,
        pageSize: this.pager.pageSize
      }).then(res => {
        const d = res.data || {}
        const list = d.list || []
        this.rows = list.map(x => {
          const bannerList = this.parseBannerJson(x.banner_imgs_json)
          return {
            bannerList,
            id: x.id,
            product_code: x.product_code,
            product_name: x.product_name || '',
            banner1: this.getBannerFirst(bannerList),
            bgColor: this.normalizeHexColor(x.bg_color),
            logo: x.logo_img
          }
        })
        this.pager.total = d.totalCount || 0
      }).finally(() => {
        this.loading = false
      })
    },
    resetSearch() {
      this.search.productCode = ''
      this.pager.pageIndex = 1
      this.loadRows()
    },
    handlePageChange(page) {
      this.pager.pageIndex = page
      this.loadRows()
    },
    handleSizeChange(size) {
      this.pager.pageSize = size
      this.pager.pageIndex = 1
      this.loadRows()
    },
    openAdd() {
      this.dialogMode = 'add'
      this.productSelectList = []
      this.form = {
        id: null,
        product_code: '',
        banner1: this.defaults.banner1 || '',
        bannerList: this.defaults.bannerList && this.defaults.bannerList.length ? [...this.defaults.bannerList] : (this.defaults.banner1 ? [this.defaults.banner1] : []),
        bgColor: this.normalizeHexColor(this.defaults.bgColor),
        logo: this.defaults.logo || ''
      }
      this.syncBannerByFileList((this.form.bannerList || []).map((url, i) => ({ name: `banner_${i + 1}`, url })))
      this.setFileList('formLogo', this.form.logo)
      this.dialogVisible = true
    },
    openEdit(row) {
      this.dialogMode = 'edit'
      this.productSelectList = [{
        product_code: row.product_code,
        product_name: row.product_code,
        product: row.product_code
      }]
      this.form = {
        id: row.id,
        product_code: row.product_code,
        banner1: this.normalizeImageUrl(row.banner1 || ''),
        bannerList: (row.bannerList && row.bannerList.length) ? row.bannerList.map(x => this.normalizeImageUrl(x)) : (row.banner1 ? [this.normalizeImageUrl(row.banner1)] : []),
        bgColor: this.normalizeHexColor(row.bgColor),
        logo: this.normalizeImageUrl(row.logo || '')
      }
      this.syncBannerByFileList((this.form.bannerList || []).map((url, i) => ({ name: `banner_${i + 1}`, url })))
      this.setFileList('formLogo', this.form.logo)
      this.dialogVisible = true
    },
    submitForm() {
      this.form.banner1 = (this.form.bannerList && this.form.bannerList[0]) || ''
      this.form.bgColor = this.normalizeHexColor(this.form.bgColor)
      if (!this.form.product_code || !this.form.banner1 || !this.form.bgColor || !this.form.logo) {
        this.$message.warning('产品编码、轮播图（至少一张）、背景色色块、logo图均为必填')
        return
      }
      const payload = {
        product_code: this.form.product_code,
        banner_imgs_json: JSON.stringify(this.form.bannerList || []),
        bg_color: this.form.bgColor,
        logo_img: this.form.logo
      }
      const req = this.dialogMode === 'add'
        ? h5scanpageconfigadd(payload)
        : h5scanpageconfigedit({ id: this.form.id, ...payload })
      req.then(() => {
        this.$message.success(this.dialogMode === 'add' ? '新增成功' : '保存成功')
        this.dialogVisible = false
        this.loadRows()
      })
    },
    removeRow(row) {
      this.$confirm('将删除该产品的H5扫码页配置，是否继续？', '提示', { type: 'warning' })
        .then(() => h5scanpageconfigdel({ id: row.id }))
        .then(() => {
          this.$message.success('删除成功')
          this.loadRows()
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.color-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: center;
}
.swatch {
  display: inline-block;
  width: 28px;
  height: 18px;
  border: 1px solid #dcdfe6;
  border-radius: 2px;
}
.upload-tip {
  color: #909399;
  font-size: 12px;
  line-height: 1;
  margin-top: 6px;
}
.color-value {
  margin-left: 10px;
  color: #606266;
  font-size: 12px;
}
.color-picker-row {
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.default-display {
  display: grid;
  grid-template-columns: repeat(4, minmax(180px, 1fr));
  gap: 14px;
  align-items: stretch;
  justify-items: center;
}
.default-item {
  padding: 8px 8px;
  min-height: 112px;
  text-align: center;
  width: 100%;
  max-width: 220px;
}
.default-label {
  font-size: 12px;
  color: #909399;
  margin-bottom: 8px;
  text-align: center;
}
.default-sub {
  font-size: 12px;
  color: #606266;
  margin: -4px 0 8px;
  text-align: center;
}
.default-image {
  width: 100%;
  height: 100%;
}
.default-action {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 8px 8px;
  min-height: 112px;
  width: 100%;
  max-width: 220px;
}
.preview-frame {
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
.empty-text {
  color: #c0c4cc;
  font-size: 12px;
}
.table-image {
  width: 120px;
  height: 64px;
  display: inline-block;
}
.container /deep/ .el-upload--picture-card,
.container /deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 72px;
  height: 72px;
  line-height: 72px;
}
.container /deep/ .hide-upload-trigger .el-upload--picture-card {
  display: none;
}
@media (max-width: 1400px) {
  .default-display {
    grid-template-columns: repeat(2, minmax(180px, 1fr));
  }
}
</style>
